
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaving-wordpress",
      function () {
        return require("private-next-pages/leaving-wordpress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaving-wordpress"])
      });
    }
  